export const RENDER_MODE = {
  ALL: 'all',
  ONLY_SELECTED: 'only_selected',
  ONLY_UNSELECTED: 'only_unselected',
};

export const getOptionViewState = (optionData, context) => {
  const { selectedIds, renderMode } = context;
  const isSelected = selectedIds.has(optionData.id);

  return {
    id: optionData.id,
    label: getLabel(optionData),
    isDisabled: isDisabledOption(context, isSelected),
    isVisible: optionData.display !== false,
    shouldRender: getShouldRender(renderMode, isSelected),
    children: optionData.children || [],
    isSelected,
  };
};

export const getGroupViewState = (groupData) => {
  return {
    id: groupData.id,
    label: groupData.label,
    isVisible: groupData.display !== false,
  };
};

const isDisabledOption = ({ multiple, maxSelectedChoices, selectedCount }, isSelected) => {
  return multiple && maxSelectedChoices && selectedCount >= maxSelectedChoices && !isSelected;
};

const getShouldRender = (renderMode, isSelected) => {
  if (renderMode === RENDER_MODE.ONLY_SELECTED && !isSelected) {
    return false;
  }

  if (renderMode === RENDER_MODE.ONLY_UNSELECTED && isSelected) {
    return false;
  }

  return true;
};

export const getLabel = (optionData) => {
  let label = optionData.label;
  if (optionData.count) {
    label += ` (${optionData.count})`;
  }
  return label;
};
